import { icons } from '@assets/icons';
import styled from '@emotion/styled';

export const StyledTable = styled.div`
  position: relative;
  padding-bottom: 32px;

  * {
    box-sizing: border-box;
  }

  .tooltip {
    position: relative;
    display: inline-flex;

    &:hover {
      .tooltip-wrapper {
        display: block;
      }
    }

    .tooltip-wrapper {
      position: absolute;
      display: none;
      right: -40px;
      top: 100%;
      padding-top: 10px;
      z-index: 99;

      &:after {
        content: '';
        position: absolute;
        top: 4px;
        right: 42px;
        width: 16px;
        height: 16px;
        transform: rotate(45deg);
        border-radius: 4px;
        background-color: black;
      }
    }

    .tooltip-content {
      min-width: 300px;
      padding: 16px 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 12px;
      background-color: black;
      color: white;
      font-size: 14px;
      white-space: nowrap;
    }
  }

  & table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    font-size: 14px;
    th:nth-of-type(1),
    td:nth-of-type(1) {
      width: 90px;
    }
    th:nth-of-type(2),
    td:nth-of-type(2) {
      width: 160px;
    }
    th:nth-of-type(3),
    td:nth-of-type(3) {
      width: 260px;
    }
    th:nth-of-type(4),
    td:nth-of-type(4) {
      width: 210px;
    }
    th:nth-of-type(5),
    td:nth-of-type(5) {
      width: 90px;
    }
    th:nth-of-type(6),
    td:nth-of-type(6) {
      width: 80px;
    }
    th:nth-of-type(7),
    td:nth-of-type(7) {
      width: 110px;
    }
    tr:first-of-type {
      td {
        border-top: none;
      }
    }

    thead {
      th {
        position: relative;
        height: 40px;
        border: 1px solid #fff;
        background-color: #00bf00;
        color: #fff;
        & .active-text {
          margin-left: 10px;
        }
        //체크박스
        & label {
          display: inline-block;
          vertical-align: -2px;
        }
        & input {
          & ~ span {
            background-color: #fff;
          }
          &:checked {
            & ~ span {
              border-color: #fff;
            }
          }
        }
      }
    }
    tbody {
      overflow-y: auto;
      max-height: 182px;
      td {
        position: relative;
        height: 40px;
        padding: 0 10px;
        border-width: 1px 1px 0 1px;
        border-style: solid;
        border-color: #e0e0e0 #fff transparent #fff;

        //체크박스
        & div[data-type='checkbox'] {
          margin: 0 auto;
          & label {
            opacity: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: transparent;
          }
        }
        //인풋박스
        & div[data-type='text'] {
          align-items: center;
          height: 40px;
          & input {
            height: 24px;
            font-size: 12px;
            &::placeholder {
              color: #ccc;
            }
          }
        }
        //버튼
        & button {
          width: 30px;
          height: 30px;
          border: none;
          background-repeat: no-repeat;
          background-size: 15px 15px;
          background-position: center;

          &.btn-modify {
            background-image: url('${icons.modify_pencil}');
          }
          &.btn-delete {
            background-image: url('${icons.deleteX}');
          }
          &.btn-add_on {
            background-image: url('${icons.preprocessing_on}');
          }
          &.btn-add_off {
            background-image: url('${icons.preprocessing_off}');
          }
        }
        & .gray {
          color: rgba(153, 153, 153, 0.5);
        }
      }
    }
  }
`;

export const StyledRecipients = styled.div`
  position: relative;
`;

export const StyledBtnAddInfo = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 32px;
  border: 1px solid #e0e0e0;
  background-color: #fafafa;
  & span {
    padding-left: 20px;
    font-size: 12px;
    background: url(${icons.addInfo_plus}) no-repeat left center;
    background-size: 16px 16px;
    color: #555;
  }
`;

export const StyledRecipientsBox = styled.div`
  position: relative;
  padding-left: 32px;
  color: #555;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
  & .txt-total_count {
    font-size: 12px;
    color: #ababab;
  }
`;

export const StyledTelBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > * + * {
    margin-left: 6px;
  }
`;

export const StyledButtonGroup = styled.div`
  button + button {
    margin-left: 4px;
  }
`;
